<template>
    <div>
        <r-badge :type="badgeType">{{ this.creditMemo.status | unKebabCase }}</r-badge>
    </div>
</template>

<script>
    import BADGES_COLOR_MAP from '@/data/badges-color-map';
    import CreditMemoModel from '@/common/models/credit-memo-model';

    export default {
        name: 'credit-memo-state-summary',
        props: {
            creditMemo: {
                type: CreditMemoModel,
                required: true,
            },
        },
        computed: {
            badgeType() {
                return BADGES_COLOR_MAP.creditMemoStatus[this.creditMemo.status];
            },
        },
    };
</script>
